import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { Config } from '../../config';

const initDatabasesMFEApiService = async () => {
  try {
    const {
      initSmApiService,
      initDatabasesApiService,
      initDedicatedOfferingService,
      initBillingPricingService,
      initKycApiService,
      initResourceLinkApiService,
      initTaggingApiService
    } =
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      await import('databases/initApiService');
    initSmApiService(RedisApiAxiosInstance, !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM);
    initDatabasesApiService(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.DATABASE
    );

    initDedicatedOfferingService(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.DEDICATED_OFFERING
    );

    initBillingPricingService(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.BILLING_PRICING
    );
    initKycApiService(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.KYC.replace('/api', '')
    );
    initResourceLinkApiService(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.PRIVATE_LINK
    );
    initTaggingApiService(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.TAGGING
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initDatabasesMFEApiService', e);
  }
};

export default initDatabasesMFEApiService;
